var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "folder-item ia-texto-corpo d-flex align-center py-1 px-2",
      class: { "folder-item--drag-over": _vm.dragOver },
      on: {
        dragover: _vm.onDragOver,
        dragleave: _vm.onDragLeave,
        drop: _vm.onDrop
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "folder-item__toggle d-flex align-center ma-0 pa-0",
          attrs: {
            type: "button",
            "aria-expanded": _vm.expanded ? "true" : "false"
          },
          on: { click: _vm.toggle }
        },
        [
          _c("icon-svg", {
            staticClass: "folder-item__chevron flex-shrink-0 mr-1",
            attrs: { name: _vm.chevronName, size: 16, color: "#8E8E8E" }
          }),
          _c(
            "span",
            { staticClass: "folder-item__icon-wrap flex-shrink-0 mr-2" },
            [
              _c("icon-svg", {
                attrs: { name: "folder-outline", size: 14, color: "#8E8E8E" }
              }),
              _c("span", {
                staticClass: "folder-item__dot",
                style: _vm.dotStyle
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass:
                "folder-item__name ia-texto-corpo az-ds-body text-truncate",
              attrs: { title: _vm.folder.name }
            },
            [_vm._v(" " + _vm._s(_vm.folder.name) + " ")]
          ),
          _c(
            "span",
            {
              staticClass: "az-ds-badge-count az-neutral flex-shrink-0 ml-auto",
              attrs: { "aria-label": _vm.countLabel }
            },
            [_vm._v(_vm._s(_vm.count || 0))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "folder-item__menu flex-shrink-0",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("BaseActionsMenu", {
            attrs: {
              "icon-only": "",
              label: "Ações da pasta",
              actions: _vm.menuActions
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }